import type { ReactElement } from 'react';
import { create } from 'zustand';

export type FieldElement = {
  key: string;
  value: ReactElement<{ condition?: unknown } & Record<string, unknown>>;
};

interface FormFieldElementsState {
  elements: FieldElement[];
  setElements: (elements: FieldElement[]) => void;
  clear: () => void;
}

export const useFormFieldElementsStore = create<FormFieldElementsState>(
  (set) => ({
    elements: [],
    setElements: (elements) => set({ elements }),
    clear: () => set({ elements: [] }),
  })
);
